module.exports = __webpack_public_path__ + "img/whatsappbg.26b929c1.svg";